import SkeletonAvatar from 'components/loaders/SkeletonAvatar';
import SkeletonGroup from 'components/loaders/SkeletonGroup';
import SkeletonText from 'components/loaders/SkeletonText';

const DetailsViewCardHeaderSkeleton = () => (
    <>
        <SkeletonAvatar />

        <SkeletonGroup>
            <SkeletonText lines={1} />

            <SkeletonText lines={1} />
        </SkeletonGroup>

        <SkeletonText lines={3} width='10px' />
    </>
);

export default DetailsViewCardHeaderSkeleton;
